<hr />
<div class="footer">
  <p class="version" style="text-align: center">{{ version }}</p>
</div>
